import React from "react";
import { Dialog } from "primereact/dialog";
import DatasetLineChart from "components/dashboard/charts/dataset-line-chart/DatasetLineChart";
import useChartInDialogStore from "store/chart-in-dialog-store";
import { T } from "services/lang/LanguageService";

const GlobalChartDialog = () => {
  const { isDialogVisible, dateFrom, dateTo, header, identifiers, setDialogVisibility } =
    useChartInDialogStore();

  const closeDialog = () => setDialogVisibility(false);

  return (
    <Dialog
      header={header || T("word.chart")}
      visible={isDialogVisible}
      onHide={closeDialog}
      style={{ width: "min(100vw, 1000px)", height: "500px" }}
      modal={false}
      resizable
      draggable
      maximizable
    >
      <DatasetLineChart
        dateFrom={dateFrom || new Date()}
        dateTo={dateTo || new Date()}
        identifiers={identifiers || []}
        dynamicHeight
        showDateSelection
        chartDialogOpen={isDialogVisible}
        title=""
        updateFrequency={10}
      />
    </Dialog>
  );
};

export default GlobalChartDialog;
